import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CivilStatus } from '../../../models/civil-status.model';
import { CivilStatusService } from '../../../services/civil-status/civil-status.service';

@Component ({
  selector: 'app-kv-civil-status-form',
  templateUrl: 'civil-status-form.html',
  styles: ['label.required:after {top: 0}']
})

export class CivilStatusFormComponent implements OnChanges, OnInit {
  @Output() civilStatusAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() civilStatusUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxCivilStatus: CivilStatus;
  addEditForm: FormGroup;
  fields: any;
  invalidSubmit: boolean;

  constructor(private fb: FormBuilder, private civilStatusSrv: CivilStatusService) {
  }

  ngOnChanges(...args: any[]) {
    this.addEditForm = this.fb.group({
      'name': new FormControl(this.dialogBoxCivilStatus.name),
      'description': new FormControl(this.dialogBoxCivilStatus.description)
    });
  }

  ngOnInit() {
    this.civilStatusSrv.getFields().subscribe(res => {
      this.fields = res;
    });
  }

  saveOrUpdate(dialogBox: any): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    let newData = Object.assign({}, this.dialogBoxCivilStatus, this.addEditForm.value);
    if (newData.id == null) {
      this.civilStatusAdded.emit(newData);
    } else {
      this.civilStatusUpdated.emit(newData);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/civil-status/civil-status-form.component.ts